import ChangeCodeDialog from './index.vue'
import Vue from 'vue'
import store from '@/store/openAccount'

let instance = null

const changeCodeService = {
    initInstance() {
        const component = Vue.extend(ChangeCodeDialog)
        component.prototype.$store = store
        instance = new component()
        const dom = document.createElement('div')
        document.body.appendChild(dom)
        instance.$mount(dom)
    },

    show(options) {
        const { aeCode, channel, linkAeCode, linkChannel } = options
        if (!instance) {
            this.initInstance()
        }

        instance.show = true
        instance.aeCode = aeCode
        instance.channel = channel
        instance.linkAeCode = linkAeCode
        instance.linkChannel = linkChannel
    },
}

export default changeCodeService
